export const getCountryName = (countryCode: string) =>
  countryCode &&
  new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode);
